import React from "react";
import logo from "./site-logo.png";

export default function SiteLogo() {
  return <img alt="ACCESS4ME logo" src={logo} />;
}
